
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton } from '@/components';
import { useLiveopsList } from '@/modules/liveops/item/model/list';
import { LiveopsOptions, LiveopsRewardType } from '@/modules/liveops/item/types';
import { ROUTE_NAME_LIVEOPS } from '@/modules/liveops/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: 'LiveopsList',
    components: { AppTable, AppButton, AppCard },
    setup() {
        const { list, total, query, fetchList, actions } = useLiveopsList(LiveopsRewardType.Milestone);

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'Id', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: LiveopsOptions.Type },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: LiveopsOptions.Status },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.DateTime, label: 'Start Time', key: 'startTime' },
                { type: TableColumnType.DateTime, label: 'Close Time', key: 'closeTime' },
                { type: TableColumnType.DateTime, label: 'End Time', key: 'endTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-gift',
                        theme: 'info',
                        tooltip: 'View milestones',
                        to: { name: ROUTE_NAME_LIVEOPS.MILESTONE.INDEX, params: { itemId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-copy',
                        theme: 'info',
                        tooltip: 'Clone',
                        to: { name: ROUTE_NAME_LIVEOPS.ITEM.CLONE(row.rewardType), params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_LIVEOPS.ITEM.DETAIL(row.rewardType), params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_LIVEOPS.ITEM.EDIT(row.rewardType), params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-pen-square',
                        theme: 'info',
                        tooltip: 'Edit content',
                        to: { name: ROUTE_NAME_LIVEOPS.ITEM.EDIT_CONTENT(row.rewardType), params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canEditContent,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: {
                            name: ROUTE_NAME_LIVEOPS.ITEM.TRANSLATE(row.rewardType),
                            params: { id: row.id },
                            query: { rewardType: row.rewardType }
                        }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'success',
                        tooltip: 'Enable',
                        onClick: () => actions.enable(row.id)
                    }),
                    canShow: (row: any) => row.canEnable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Disable',
                        onClick: () => actions.disable(row.id)
                    }),
                    canShow: (row: any) => row.canDisable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_LIVEOPS };
    }
});
